varying vec2 vUv;
uniform vec2 u_res;
uniform float u_time;
uniform float u_appear;
uniform float u_destroy;
uniform sampler2D u_noise;

#define PI 3.14159265359
#define TWO_PI 6.28318530718

vec2 hash( vec2 p )
{
	p = vec2( dot(p,vec2(127.1,311.7)),
			 dot(p,vec2(269.5,183.3)) );
	return -1.0 + 2.0*fract(sin(p)*43758.5453123);
}

float noise( in vec2 p )
{
	const float K1 = 0.366025404; // (sqrt(3)-1)/2;
	const float K2 = 0.211324865; // (3-sqrt(3))/6;
	
	vec2 i = floor( p + (p.x+p.y)*K1 );
	
	vec2 a = p - i + (i.x+i.y)*K2;
	vec2 o = (a.x>a.y) ? vec2(1.0,0.0) : vec2(0.0,1.0);
	vec2 b = a - o + K2;
	vec2 c = a - 1.0 + 2.0*K2;
	
	vec3 h = max( 0.5-vec3(dot(a,a), dot(b,b), dot(c,c) ), 0.0 );
	
	vec3 n = h*h*h*h*vec3( dot(a,hash(i+0.0)), dot(b,hash(i+o)), dot(c,hash(i+1.0)));
	
	return dot( n, vec3(70.0) );
}

float fbm(vec2 uv)
{
	float f;
	mat2 m = mat2( 1.6,  1.2, -1.2,  1.6 );
	f  = 0.5000*noise( uv+(u_time*0.5) ); uv = m*uv;
	f += 0.2500*noise( uv-(u_time*0.25) ); uv = m*uv;
	f += 0.1250*noise( uv+(u_time*0.1) ); uv = m*uv;
	f += 0.0625*noise( uv-(u_time*0.05) ); uv = m*uv;
	f = 0.5 + 0.5*f;
	return f;
}

void main() {
  float aspect = u_res.x / u_res.y;

  vec2 ndc = (vUv - 0.5) * 2.0;
  ndc.x *= aspect;
  ndc.y += u_destroy*2.3;
  // 
  	vec2 q = ndc;
	q.x *= 3.;
	q.y *= 2.;
  q.y += 0.5;
	float strength = 5.;
	float T3 = max(3.,1.25*strength)*u_time*0.5;
	q.y -= 0.25;
	float n = fbm(strength*q - vec2(0,T3));
	float c = 1. - 16. * pow( max( 0., length(q*vec2(1.8+q.y*1.5,.75) ) - n * max( 0., q.y+.25 ) ),1.2 );
//	float c1 = n * c * (1.5-pow(1.25*uv.y,4.));
	float c1 = n * c * (1.5-pow(2.50*ndc.y,4.));
	c1=clamp(c1,0.,1.);

	vec3 col = vec3(1., 0.5, c1*c1*c1*c1*c1*c1);
  	float a = c * (1.-pow(ndc.y,3.));
    a = clamp(a, 0., 1.);
    
float globalMaskNoise = texture2D(u_noise, vUv ).r;
globalMaskNoise-=1. ;
globalMaskNoise+=u_appear*2. ;
globalMaskNoise = clamp(globalMaskNoise, 0., 1.);
	gl_FragColor = vec4( mix(vec3(0.),col,a), mix(vec3(0.),col,a).r);
	gl_FragColor = vec4( vec3(0.9137, 0.5922, 0.5686), mix(vec3(0.),col,a).r* globalMaskNoise);
	
}
